(ns frontend.view.nev.kyc.process-status-views.event
  (:require
   [re-frame.core :as rf]
   [frontend.view.nev.kyc.process-status-views.sub :as sub]
   [frontend.controller.websocket.event :as ws]
   [clojure.set :as set]))

(rf/reg-event-fx
 ::send-reminder-comment-success
 (fn [{db :db} [_ signatory-id]]
   {:db (update db ::sub/reminding-signatory-ids disj signatory-id)}))

(rf/reg-event-fx
 ::send-reminder-comment-failed
 (fn [{db :db} [_ signatory-id]]
   (js/console.log "Reminding failed")
   {:db (update db ::sub/reminding-signatory-ids disj signatory-id)}))

(rf/reg-event-fx
 ::send-reminder-comment
 (fn [{:keys [db] :as _cofx} [_ esign-process-id email signatory-id]]
   {:db       (update db ::sub/reminding-signatory-ids set/union #{signatory-id})
    ::ws/send {:id         :esign/remind
               :body       {:esign-process-id esign-process-id
                            :signatory-email  email
                            :signatory-id     signatory-id}
               :on-success [::send-reminder-comment-success signatory-id]
               :on-error   [::send-reminder-comment-failed signatory-id]}}))

;; V2

(rf/reg-event-fx
 ::v2-send-reminder-comment-success
 (fn [{db :db} [_ signatory-id]]
   {:db (update db ::sub/reminding-signatory-ids disj signatory-id)}))

(rf/reg-event-fx
 ::v2-send-reminder-comment-failed
 (fn [{db :db} [_ signatory-id]]
   (js/console.log "Reminding failed")
   {:db (update db ::sub/reminding-signatory-ids disj signatory-id)}))

(rf/reg-event-fx
 ::v2-send-reminder-comment
 (fn [{:keys [db] :as _cofx} [_ esign-process-id email signatory-id]]
   {:db       (update db ::sub/reminding-signatory-ids set/union #{signatory-id})
    ::ws/send {:id         :esign-v2/remind
               :body       {:esign-process-id esign-process-id
                            :signatory-id     signatory-id}
               :on-success [::v2-send-reminder-comment-success signatory-id]
               :on-error   [::v2-send-reminder-comment-failed signatory-id]}}))
